import { useSearchParams } from 'react-router-dom';

/**
 * Returns `true` when the app is running in standalone mode (URL parameter `host` is not `revit` and ENVIRONMENT is `Local` or `Dev`)
 */

const IS_DEV_ENV =
    import.meta.env.VITE_ENVIRONMENT === 'Local Environment' || import.meta.env.VITE_ENVIRONMENT === 'Dev Environment';

export const useIsStandaloneMode = (): boolean => {
    const [searchParams] = useSearchParams();
    return IS_DEV_ENV && searchParams.get('host') !== 'revit';
};
